import style from "./Skill.module.css";
import SectionHeader from "../UI/SectionHeader";
import github from "../../Assets/Images/github1.svg";
import jquery from "../../Assets/Images/jquery.svg";
import javascript from "../../Assets/Images/javascript.svg";
import reactIcon from "../../Assets/Images/reactIcon.svg";
import tailwind from "../../Assets/Images/tailw.svg";
import VS from "../../Assets/Images/VS.svg";
import html from "../../Assets/Images/html5.svg";
import css from "../../Assets/Images/devicon.svg";
import { useInView } from "react-intersection-observer";
import UtilityContext from "../Store/Context/UtilityContext";
import { useContext } from "react";
import Modal from "../UI/Modal";
import Backdrop from "../UI/Backdrop";
import MoreInfo from "./MoreInfo";
const Skill = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "100%",
    threshold: 1,
  });
  const cxt = useContext(UtilityContext);
  const skills = [
    {
      name: "LANGUAGES",
      id: "s1",
      sub: [
        {
          name: "Javascript- ES6",
          icon: javascript,
          id: "ss1a",
          info: "I write clean and well optimized ES6 codes, I'm very passionate about Javascript as a result I tend to constantly update myself on the newest innovations to the language. I'll write clean JS codes to give your website the dynamic touch you need.",
        },
        {
          name: "CSS/SASS",
          icon: css,
          id: "ss1b",
          info: "I write well structure and optimize CSS codes to give your website the appearance and feel you want. I also use SASS to make CSS even more efficient and clean.",
        },
        {
          name: "HTML",
          icon: html,
          id: "ss1c",
          info: "Using HTML, i'll write well structured and clean MarkUps for your website whilst keeping up with the global best practice.",
        },
      ],
    },
    {
      name: "FRAMEWORKS",
      id: "s2",
      sub: [
        {
          name: "React",
          icon: reactIcon,
          id: "ss2a",
          info: "I use React in combinatation with CSS modules to create mordern dynamic website that gives you the look and feel you desire. I'm comfortable with using Functional React Components and Class Based components.Combining my Indepth knowledge of mordern JavaScript I'm able to execute all desired functionality in React.",
        },
        {
          name: "JQuery",
          icon: jquery,
          id: "ss2b",
          info: "I use this Javascript library to write better and cleaner code when needed.",
        },
        {
          name: "Tailwind",
          icon: tailwind,
          id: "ss2c",
          info: "Capitalizing on the component based infrastructure of this CSS framework, i build reuseable and clean CSS components.",
        },
      ],
    },
    {
      name: "UTILITY TOOLS",
      id: "s3",
      sub: [
        {
          name: "Chrome Dev-tools",
          icon: tailwind,
          id: "ss3a",
          info: "I use this Tool to test and debug my codes.",
        },
        {
          name: "React Dev-tools",
          icon: tailwind,
          id: "ss3b",
          info: "My proficiency in the React dev tool helps me debug my React apps faster and more efficiently.",
        },
        {
          name: "Git/GitHub",
          icon: github,
          id: "ss3c",
          info: "I use GIT as a version control tool to save and keep track of changes in my projects.",
        },
        {
          name: "VS-code",
          icon: VS,
          id: "ss3d",
          info: " VS code is my most prefered IDE.",
        },
      ],
    },
    {
      name: "SOFT SKILLS",
      id: "s4",
      sub: [
        {
          name: "Good Communication",
          id: "ss4a",
          info: " I have excellent commuication skill which leads to better problem solving and problem Understanding. English is my Vernacular and my proficiency level is 8/10.",
        },
        {
          name: "Time Manegement",
          id: "ss4b",
          info: "I'm very Time consious and this helps me to deliver my projects and task on schedule.",
        },
        {
          name: "Organization",
          id: "ss4c",
          info: "I keep track of my codes and I tend to draw up an organization schema for various task.",
        },
        {
          name: "Teamwork",
          id: "ss4d",
          info: "I function well in a team, either large or small. I've been part of several taems where I contributed immersely to the grow of the team as a whole.",
        },
      ],
    },
  ];
  const backdropHandler = () => {
    cxt.closeSkillModal();
    if (cxt.moreInfoIsOpen) {
      cxt.closeMoreInfoHandler();
    }
  };
  return (
    <>
      {cxt.skillIsOpen && cxt.screenWidth < 900 && (
        <Backdrop onClick={backdropHandler} />
      )}
      <SectionHeader
        className={style.sectionHeader}
        title="MY"
        titleSpan="SKILLSET"
        span="C"
      />
      <section
        ref={ref}
        className={`${style["skill-section"]} ${inView ? style.animation : ""}`}
      >
        {skills.map((item) => {
          return (
            <div
              className={style.list}
              key={item.id}
              onClick={() => {
                if (cxt.screenWidth < 900) {
                  cxt.openSkillModal(item);
                }
              }}
            >
              {cxt.screenWidth < 900 && <h4>{item.name}</h4>}

              {cxt.screenWidth > 900 && (
                <>
                  <Modal className={style.modal} skill={item} />
                </>
              )}
            </div>
          );
        })}
      </section>
      {cxt.moreInfoIsOpen && cxt.screenWidth > 900 && (
        <MoreInfo className={style["moreInfo__desktop"]} />
      )}
    </>
  );
};
export default Skill;
